module.exports = __webpack_public_path__ + "img/reklamace.66913388.svg";